module.exports = __webpack_public_path__ + "img/tarj3-5.ab612a73.svg";